import { paginatedIndexRouteOptions } from './paginatedIndexQuery';

/**
 * Route helper utilities for Specialists.
 *
 * Specialists are a single global resource (no site_context). They are managed
 * exclusively under the root /admin section, so the helper always resolves to
 * the `admin_specialists` route helpers. The signature is kept (siteContext
 * arg) for call-site compatibility, but the argument is ignored.
 */
export function createSpecialistRouteHelper(_siteContext, routes) {
  return {
    index: (extra) => routes.admin_specialists(paginatedIndexRouteOptions(extra)),
    new: () => routes.new_admin_specialist(),
    edit: (id) => routes.edit_admin_specialist(id, paginatedIndexRouteOptions()),
    update: (id) => routes.admin_specialist(id, paginatedIndexRouteOptions()),
    destroy: (id) => routes.admin_specialist(id, paginatedIndexRouteOptions()),
    reorder: () => routes.reorder_admin_specialists(),
  };
}
